import { render, staticRenderFns } from "./Microphone.vue?vue&type=template&id=7cab0c85&scoped=true&"
import script from "./Microphone.vue?vue&type=script&lang=js&"
export * from "./Microphone.vue?vue&type=script&lang=js&"
import style0 from "./Microphone.vue?vue&type=style&index=0&id=7cab0c85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cab0c85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
